import type { ComponentProps } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

type Props = {
  color?: 'green' | 'grey';
} & Pick<ComponentProps<typeof Chip>, 'size'>;

export const StartingPitcher = ({
  color = 'green',
  size = 'medium',
}: Props) => {
  const { formatMessage } = useIntl();
  return (
    <Tooltip
      title={formatMessage({
        defaultMessage: 'Starting Pitcher',
      })}
    >
      <Chip size={size} color={color}>
        <FormattedMessage defaultMessage="SP" />
      </Chip>
    </Tooltip>
  );
};
